import { render, staticRenderFns } from "./brainfit.vue?vue&type=template&id=34de81d9&scoped=true&"
import script from "./brainfit.vue?vue&type=script&lang=js&"
export * from "./brainfit.vue?vue&type=script&lang=js&"
import style0 from "./brainfit.vue?vue&type=style&index=0&id=34de81d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de81d9",
  null
  
)

export default component.exports